import * as React from "react";

function SvgSingular(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 26"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fill="#3088F4" fillRule="evenodd">
        <path d="M13.42 7.18a10.25 10.25 0 011.84 6 .07.07 0 00.14 0c.17-.28.31-.56.45-.85a9 9 0 00.19-7 9.44 9.44 0 00-7.1-2c-.08 0-.1.12 0 .15a10 10 0 014.48 3.7z" />
        <path d="M16.85 12.81a10.17 10.17 0 01-4.45 4.8.08.08 0 000 .15 9.57 9.57 0 001.41-.11 9.43 9.43 0 005.76-3.29 9.46 9.46 0 00-1.85-7.2.08.08 0 00-.14.06 10.11 10.11 0 01-.73 5.59zM7 7.14a9.78 9.78 0 015.81 1.44.08.08 0 00.11-.1A9 9 0 006.55 4a9.62 9.62 0 00-5.3 5.18.08.08 0 00.12.09A10.58 10.58 0 017 7.14z" />
        <path d="M14 18.73c-.523.08-1.051.12-1.58.12a9.77 9.77 0 01-5.28-1.57.08.08 0 00-.11.1c.176.317.373.62.59.91a9.55 9.55 0 006 3.64 9.61 9.61 0 005.38-5.2.08.08 0 00-.12-.09A10.77 10.77 0 0114 18.73z" />
        <path d="M6.79 19a9.61 9.61 0 01-1.91-6.17.08.08 0 00-.14 0c-.14.23-.27.47-.39.71a9.12 9.12 0 00-.23 7 9.48 9.48 0 007.21 2 .08.08 0 000-.15A10.54 10.54 0 016.79 19z" />
        <path d="M3.26 13.06a9.6 9.6 0 014.41-4.72.08.08 0 000-.15h-.81a9.09 9.09 0 00-6.21 3.3 9.52 9.52 0 001.82 7.26.08.08 0 00.14-.06 10.61 10.61 0 01.65-5.63z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSingular);
